import { useDispatch, useSelector } from "react-redux";

import { CONTACTS_SEARCH_RESULTS_LOWER_LIMIT } from "app/pages/sales-intelligence/modules/company-analysis/constants/contacts";
import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { contactsTableFiltersChangedAction } from "app/pages/sales-intelligence/modules/company-analysis/store/contacts/action-creators";
import { CONTACTS_SEARCH_TABLE_INITIAL_PAGE } from "app/pages/sales-intelligence/sub-modules/contacts-search/constants/table";
import { selectContactsTableSearchText } from "app/pages/sales-intelligence/modules/company-analysis/store/contacts/selectors";
import { StyledSearchTextBox } from "app/pages/sales-intelligence/modules/lists/containers/ListTabsContainer/styles";
import { selectNumberOfContactsSearchResults } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";
import { selectLoadingContactStatus } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";
import { translate } from "app/filters/i18nFilter";

import { StyledSearchBoxContainer } from "./styles";

const SearchTextBox = () => {
    const dispatch = useDispatch();

    const searchText = useSelector(selectContactsTableSearchText);
    const numberOfSearchResults = useSelector(selectNumberOfContactsSearchResults);
    const isLoadingContactsStatus = useSelector(selectLoadingContactStatus);

    function handleSearch(text: string) {
        if (text !== searchText) {
            if (text !== "" && numberOfSearchResults > CONTACTS_SEARCH_RESULTS_LOWER_LIMIT) {
                companyAnalysisTrackingService.contacts.trackSearchByContactName();
            }

            dispatch(
                contactsTableFiltersChangedAction({
                    searchText: text,
                    page: CONTACTS_SEARCH_TABLE_INITIAL_PAGE,
                }),
            );
        }
    }

    return (
        <StyledSearchBoxContainer isDisabled={isLoadingContactsStatus}>
            <StyledSearchTextBox
                isDisabled={isLoadingContactsStatus}
                searchText={searchText}
                onChange={handleSearch}
                placeholder={translate("si.advanced_search.results_section.contacts.search_placeholder")}
            />
        </StyledSearchBoxContainer>
    );
};

export default SearchTextBox;
